"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _types = require("../types");

var getFontColor = function getFontColor(disabled, type, c) {
  if (disabled) return c.grey.c;
  var dark = [_types.ButtonTypes.TERTIARY, _types.ButtonTypes.WHITE];
  return dark.some(function (v) {
    return type === v;
  }) ? c.black.a : c.white.a;
};

var _default = getFontColor;
exports.default = _default;